export const API_LOCALES = [{
  region: 'us',
  locale: 'en_US',
  display: 'English',
  active: true,
  default: true,
  /*
}, {
  region: 'us',
  locale: 'es_MX',
  */
}, {
  region: 'us',
  locale: 'pt_BR',
  display: 'Português (Brasil)',
  active: true,
  /*
}, {
  region: 'eu',
  locale: 'en_GB',
  */
}, {
  region: 'eu',
  locale: 'es_ES',
  display: 'Español',
  active: true,
}, {
  region: 'eu',
  locale: 'fr_FR',
  display: 'Français',
  active: true,
}, {
  region: 'eu',
  locale: 'ru_RU',
  display: 'Русский',
  active: true,
}, {
  region: 'eu',
  locale: 'de_DE',
  display: 'Deutsch',
  active: true,
  /*
}, {
  region: 'eu',
  locale: 'pt_PT',
  */
}, {
  region: 'eu',
  locale: 'it_IT',
  display: 'Italiano',
  active: true,
  /*
}, {
  region: 'kr',
  locale: 'ko_KR',
  display: '한국어',
  active: false,
}, {
  region: 'tw',
  locale: 'zh_TW',
  display: '繁體中文',
  active: false,
  */
}];
